import { show, hide } from 'redux-modal'
import { SubmissionError } from 'redux-form'
import { rest } from 'services'
import { isApiError } from 'services/rest/helpers'
import { selectors } from './components/BOTSkuFindLowerPriceInfo'
import { FIND_LOWER_PRICE_MODAL } from './constants'
import { showSuccessfulSubmitModal, hideSuccessfulSubmitModal } from '../SuccessfulSubmitModal/actions'
import { getFindLowerPriceModalUrl } from './helpers'

const { getFindLowerPriceSkuId } = selectors

export const showFindLowerPriceModal = skuId =>
  show(FIND_LOWER_PRICE_MODAL, { pageSrc: getFindLowerPriceModalUrl(skuId) })

export const hideFindLowerPriceModal = () => hide(FIND_LOWER_PRICE_MODAL)

export const submitLowerPrice = values => (dispatch, getState) => {
  const state = getState()
  const skuId = getFindLowerPriceSkuId(state)

  return rest.api
    .submitLowerPriceForm({ ...values, skuId })
    .then(() => {
      dispatch(hideFindLowerPriceModal())

      dispatch(showSuccessfulSubmitModal({
        description: 'Your information was successfully sent',
        confirmButtonText: 'Continue Shopping',
        onConfirm: () => dispatch(hideSuccessfulSubmitModal())
      }))
    })
    .catch(err => {
      throw isApiError(err) ? new SubmissionError({ _error: err.statusList[0].description }) : err
    })
}
